import { ADDRESS_FORM_ID_BY_COUNTRY } from '@wix/form-multiline-address';
export const convertToAddressTemplates = (templates)=>Object.entries(ADDRESS_FORM_ID_BY_COUNTRY).reduce((accumulator, [country, id])=>{
        const template = templates.find((candidate)=>candidate.id === id);
        if (template) {
            accumulator.push({
                country,
                id,
                template
            });
        }
        return accumulator;
    }, []);

//# sourceMappingURL=address-templates.js.map